import attachEnterAsClick from 'utils/attachEnterAsClick';

const accordionItemHeadingClick = function(this: HTMLElement): void {
    // Slide open the accordion content
    const contentItem = this.closest<HTMLElement>('.accordion-item');
    const contentInner = contentItem?.querySelector<HTMLElement>(
        '.accordion-content-display'
    );
    const content =
        contentItem?.querySelector<HTMLElement>('.accordion-content');
    if (content && contentInner) {
        if (contentItem?.classList.contains('is-open')) {
            this.setAttribute('aria-expanded', 'false');
            contentItem.classList.remove('is-open');
            content.style.height = `${contentInner.offsetHeight}px`;
            setTimeout(() => {
                content.style.height = '0px';
            }, 10);
        } else {
            this.setAttribute('aria-expanded', 'true');
            contentItem?.classList.add('is-open');
            content.style.display = 'block';
            setTimeout(() => {
                content.style.height = `${contentInner.offsetHeight}px`;
            }, 0);
        }
    }
};

const accordionItemContentTransitionEnd = function(this: HTMLElement): void {
    if (this.offsetHeight > 0) {
        this.style.height = 'auto';
    }
    if (this.offsetHeight === 0 && !this.closest('.accordion-item.is-open')) {
        this.style.display = 'none';
    }
};

const accordionItemInit = (el: HTMLElement): void => {
    const heading = el.querySelector<HTMLButtonElement>(
        '.accordion-heading button'
    );
    const content = el.querySelector<HTMLElement>('.accordion-content');

    heading?.setAttribute('aria-expanded', 'false');
    heading?.addEventListener('click', accordionItemHeadingClick);
    attachEnterAsClick(heading, true);

    content?.addEventListener(
        'transitionend',
        accordionItemContentTransitionEnd
    );

    // // pre set height of open items to enable animation
    if (content && el.classList.contains('is-open')) {
        heading?.setAttribute('aria-expanded', 'true');
        const contentHeight = content?.querySelector<HTMLElement>(
            '.accordion-content-display'
        )?.offsetHeight;
        content.style.height = `${contentHeight}px`;
    }
};

const accordionInit = (): void => {
    const accordionItems =
        document.querySelectorAll<HTMLElement>('.accordion-item');

    if (accordionItems.length > 0) {
        accordionItems.forEach(accordionItemInit);
    }
};

const openAccordionFromUrl = (): void => {
    const { hash } = window.location;
    let accordionButton: HTMLElement | null = null;
    let contentInner: HTMLElement | null = null;
    let content: HTMLElement | null = null;
    if (hash) {
        const hashElement = document.querySelector(hash);
        if (hashElement?.classList.contains('accordion-item')) {
            accordionButton = hashElement.querySelector<HTMLElement>('.accordion-title');
            contentInner = hashElement.querySelector<HTMLElement>('.accordion-content-display');
            content = hashElement.querySelector<HTMLElement>('.accordion-content');
        } else if (hashElement?.closest('.accordion-item')) {
            const accordionElement = hashElement.closest('.accordion-item');
            accordionButton = accordionElement?.querySelector<HTMLElement>('.accordion-title') ?? null;
            contentInner = accordionElement?.querySelector<HTMLElement>('.accordion-content-display') ?? null;
            content = accordionElement?.querySelector<HTMLElement>('.accordion-content') ?? null;
        }

        if (content && contentInner) {
            const accordionButtonEl = accordionButton;
            const contentEl = content;
            const contentInnerEl = contentInner;

            accordionButtonEl?.setAttribute('aria-expanded', 'true');
            hashElement?.classList.add('is-open');
            contentEl.style.display = 'block';
            setTimeout(() => {
                contentEl.style.height = `${contentInnerEl.offsetHeight}px`;
            }, 0);
        }
    }
};

document.addEventListener('DOMContentLoaded', async() => {
    // initialize accordion
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    await accordionInit();
    // open accordion item
    openAccordionFromUrl();
});

export { accordionItemInit };
